export default "/images/tips.png?e2ec9555222b68c4fd709ba167ac717e";